import React from "react";

const MONTH_ABBREV = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

const AppleCalendarIcon: React.FC<{ className?: string }> = ({
  className = "w-10 h-10 shrink-0",
}) => {
  const date = new Date();
  const month = MONTH_ABBREV[date.getMonth()];
  const day = date.getDate();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      className={className}
      role="img"
      aria-hidden
    >
      <rect width="48" height="48" rx="9" ry="9" fill="#f5f5f0" />
      <path
        d="M0 9 Q0 0 9 0 L39 0 Q48 0 48 9 L48 16 L0 16 L0 9 Z"
        fill="#FF3B30"
      />
      <text
        x="24"
        y="11.5"
        textAnchor="middle"
        fill="#fff"
        fontSize="7"
        fontWeight="600"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
      >
        {month}
      </text>
      <text
        x="24"
        y="38"
        textAnchor="middle"
        fill="#1d1d1f"
        fontSize="20"
        fontWeight="500"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
      >
        {day}
      </text>
    </svg>
  );
};

export default AppleCalendarIcon;
